import React from 'react';
import OrderSelect, { OrderSelectProps } from '../../Common/Select';
import { useCompanyIMDGGetAll } from '../../../../../../hooks/api/order';

function SelectCompanyIMDG({
  fetch,
  selectProps = {},
  rest = {},
  ...props
}: OrderSelectProps) {
  const dualUseGet = useCompanyIMDGGetAll();

  return (
    <OrderSelect
      fetch={dualUseGet}
      selectProps={selectProps}
      rest={rest}
      {...props}
    />
  );
}

export default SelectCompanyIMDG;
